import React, { useState } from "react";
import "./HotelListMainCard.scss";
import { useGlobalState } from "../../../../services/context/AuthContext";

interface HotelListMainCardProps {
  name: string;
  location: string;
  rating: string;
  tripAdvisorReviewCount: number;
  discount: string;
  dealBadge?: string;
  mainImage: string;
  thumbnails: string[];
  price: {
    old: number;
    current: number;
    taxes: number;
  };
  features: string[];
  viewers: number;
  EMTCommonId: string;
  onDetailsToggle?: (id: string) => void;
  onViewRoomClick?: () => void;
}

const HotelListMainCard: React.FC<HotelListMainCardProps> = ({
  name,
  location,
  rating,
  tripAdvisorReviewCount,
  discount,
  dealBadge,
  mainImage,
  thumbnails,
  price,
  features,
  viewers,
  EMTCommonId,
  onDetailsToggle,
  onViewRoomClick,
}) => {
  const [hoveredImage, setHoveredImage] = useState<string | null>(null);
  const displayImage = hoveredImage || mainImage;

  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";

  return (
    <div className="mb-3 hotel-list-wrapper" style={{ cursor: "default" }}>
      <div className="row hotel-list-card">
        {/* Image Section */}
        <div className="col-md-4 card-image-section">
          <div className="gallery-container">
            <img src={displayImage} alt={name} className="main-image" />
          </div>
          <div className="hotel-details-toggle text-primary text-sm font-medium mb-2 text-start ms-3">
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={(e) => {
                e.stopPropagation();
                onDetailsToggle?.(EMTCommonId);
              }}
            >
              Hotel Details
            </span>
          </div>
        </div>

        {/* Content Section */}
        <div className="col-md-8 card-content d-flex justify-content-between flex-grow-1">
          {/* Hotel Info */}
          <div className="hotel-info">
            <div className="hotel-name fw-semibold">
              {name}{" "}
              <span className="stars text-warning">
                {"★".repeat(Math.round(parseFloat(rating)))}
              </span>
            </div>

            <div className="location text-muted">
              <i className="fa-solid fa-location-dot me-2"></i>
              {location}
            </div>

            <div className="features mt-2">
              {features.slice(0, 5).map((feature, index) => (
                <div className="feature" key={index}>
                  <i className="fa-solid fa-check-double me-1 text-success"></i>
                  {feature}
                </div>
              ))}
            </div>

            <div className="viewers mt-2">
              <i className="fa-solid fa-eye me-1"></i>
              {viewers} People viewing
            </div>
          </div>

          {/* Price & Button */}
          <div className="price-info price-info-top text-md-end">
            <div className="rating mb-1 ">
              <div className="rating-text text-muted small">
                {tripAdvisorReviewCount} reviews
              </div>
              <div className="rating-score fw-bold">
                {tripAdvisorReviewCount}
              </div>
            </div>

            <div className="old-price text-decoration-line-through text-danger">
              {currency} {price.old.toLocaleString()}
            </div>

            <div className="current-price fw-bold">
              <span className="fs-5">{currency} </span>{" "}
              {price.current.toLocaleString()}
            </div>

            <div className="taxes text-muted small">
              + {currency} {price.taxes.toLocaleString()} Taxes & fees
            </div>

            <div className="per-night small text-muted mb-2">Per Night</div>

            <button
              className="btn btn-primary view-button"
              onClick={(e) => {
                e.stopPropagation();
                onViewRoomClick?.();
              }}
            >
              View Room
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelListMainCard;
